<template>
  <div class="drive-container d-flex flex-column" :class="{ 'no-scroll': createDialog }"
    @dragover.prevent="handleDragOver" @dragleave.prevent="handleDragLeave" @drop.prevent="handleDrop">

    <!-- Overlay para indicar zona de drop -->
    <div v-if="showDropZone" class="drop-zone-overlay d-flex flex-column align-center justify-center">
      <v-avatar color="transparent" :size="84" class="mb-4">
        <lucide-upload-cloud color="#4dd453" :size="52"
          style="width: 52px; transform: translateY(-5px);"></lucide-upload-cloud>
      </v-avatar>
      <h3 class="mb-2" style="font-weight: 500; font-size: 1.5rem;">Suelta tus archivos aquí</h3>
      <p class="text-body-2 grey--text text--darken-1 mb-3">
        Suelta para procesar automáticamente PDFs o imágenes
      </p>
    </div>

    <!-- Contenido Principal -->
    <div class="drive-content d-flex">
      <!-- Navegación lateral -->
      <v-navigation-drawer v-if="false" permanent :mini-variant.sync="minimize" class="drive-sidebar"
        style="position: relative;">


        <v-btn v-if="false" icon small @click.stop="minimize = !minimize" class="toggle-btn"
          style="position: absolute; z-index: 100; top: 14px;" :style="minimize ? 'right: -30px;' : 'right: 20px;'">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-menu-icon lucide-menu">
            <line x1="4" x2="20" y1="12" y2="12" />
            <line x1="4" x2="20" y1="6" y2="6" />
            <line x1="4" x2="20" y1="18" y2="18" />
          </svg>
        </v-btn>

        <v-list nav dense>
          <v-list-item to="/" class="sidebar-item d-flex align-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-house-icon lucide-house">
              <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
              <path
                d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            </svg>
            <span v-if="!minimize" class="ml-2">Inicio</span>
          </v-list-item>

          <v-list-item to="/material" class="sidebar-item">
            <v-list-item-icon>
              <v-icon>mdi-file-document-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-if="!minimize">Material</v-list-item-title>
          </v-list-item>

          <v-list-item to="/templates" class="sidebar-item">
            <v-list-item-icon>
              <v-icon>mdi-file-table-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-if="!minimize">Templates</v-list-item-title>
          </v-list-item>

          <v-list-item to="/explora" class="sidebar-item">
            <v-list-item-icon>
              <v-icon>mdi-earth</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-if="!minimize">Explora</v-list-item-title>
          </v-list-item>

          <v-divider class="my-3"></v-divider>
          <div class="px-4 subtitle-2 grey--text text--darken-1 mb-2" v-if="!minimize">Otros de SeleAI</div>

          <v-list-item to="/transcripciones" class="sidebar-item">
            <v-list-item-icon>
              <v-icon>mdi-transcribe</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-if="!minimize">Transcripciones</v-list-item-title>
          </v-list-item>
        </v-list>

        <div class="bottom-sidebar">
          <v-list>
            <v-list-item to="/ayuda" class="sidebar-item">
              <v-list-item-icon>
                <v-icon>mdi-help-circle-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-if="!minimize">Ayuda y Feedback</v-list-item-title>
            </v-list-item>
          </v-list>

          <div class="premium-box mx-4 my-4 pa-4" v-if="!minimize">
            <div class="d-flex align-center mb-2">
              <v-icon color="white" small class="mr-2">mdi-lightning-bolt</v-icon>
              <span class="font-weight-bold white--text">¿Necesitas más créditos?</span>
            </div>
            <div class="white--text mb-3 text-caption">Descubre los planes</div>
            <v-btn block color="white" class="black--text font-weight-bold" small>Compra</v-btn>
          </div>
        </div>
      </v-navigation-drawer>


      <!-- Área de contenido principal -->
      <div class="drive-main-content flex-grow-1 mx-auto" :class="$vuetify.breakpoint.xs ? '' : 'px-2'"
        :style="{ width: isNavVisible ? `calc(100% - ${navDrawerWidth}px)` : '100%' }">

        <div style="max-width: 1200px;" class="mx-auto ">
          <!-- Header con el nombre del grado -->
          <div v-if="!selectedSubject" class="grado-header px-6 pt-5 pb-4 rounded-t-xl mt-5" style="min-height: 84px;">
            <div class="d-flex align-center">
              <div class="course-icon mr-3" style="height: 42px; width: 42px;">
                <v-img v-if="educationInfo && educationInfo.center_icon_url"
                  :src="axios.defaults.baseURL + educationInfo.center_icon_url" height="32" width="32"
                  class="pa-1 rounded-lg" style="width: 32px; height: 32px;" contain></v-img>
              </div>
              <div v-if="educationInfo">
                <div class="font-weight-bold font-rubik text-h6">{{ educationInfo.course_name }}</div>
                <div class="subtitle-1 grey--text text--darken-1 font-rubik">{{ educationInfo.center_name }}</div>
              </div>
            </div>
          </div>

          <!-- Barra de navegación de migas de pan -->
          <div v-if="selectedSubject" class="breadcrumb font-rubik px-3 py-1 mt-4 d-flex align-center">
            <v-btn icon small color="grey darken-1" @click="goBackToSubjects" class="">
              <lucide-home :size="13" />
            </v-btn>
            <span class="mr-2 grey--text font-rubik" style="margin-top: 1px;">/</span>
            <div class="d-flex align-center">
              <v-img v-if="false && educationInfo && educationInfo.center_icon_url"
                :src="axios.defaults.baseURL + educationInfo.center_icon_url" height="18" width="18" contain
                class="mr-1 course-icon-small"></v-img>
              <span class="font-weight-bold font-rubik" style="font-size: 14px; margin-top: 1px;">{{
                selectedSubject.name }}</span>
            </div>
          </div>

          <div v-if="selectedSubject" class="mt-4 d-flex flex-column pa-6 pt-8 pb-4 pt-4 white rounded-t-xl px-12">
            <span class="font-weight-bold font-rubik" style="font-size: 1.5rem; margin-top: 1px;">{{
              selectedSubject.name }}</span>
            <div style="border-bottom: 2px solid rgb(24 29 25 / 62%); width: 100%;" class="mt-2"></div>
          </div>

          <!-- Vista de asignaturas o documentos -->
          <ViewSubjects v-if="!selectedSubject" class="rounded-b-xl" :is-community-view="isCommunityView"
            :community-id="communityId" @select-subject="showSubjectDocuments" />

          <ViewDocuments v-else class="pt-1" :subject-id="$route.query.subject" />
        </div>


        <!-- Blur effect -->
        <div class="blur-effect"></div>

        <!-- Button container -->
        <div
          style="position: fixed; bottom: 0px; right: 0; left: 0; width: 100%; z-index: 100; height: 100px; pointer-events: none;"
          class="d-flex align-center justify-center">
          <div style="z-index: 100; width: 100%; z-index: 100;" class="d-flex align-center justify-center">
            <v-btn color="primary-btn" @click="openUploadDialog"
              style="z-index: 100; padding-left: 16px !important; pointer-events: auto;">
              <lucide-upload :size="16" class="mr-2" />
              Subir apuntes
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Botón para mostrar/ocultar el panel de chat -->
      <v-btn v-if="false && !isNavVisible" fab small color="primary" class="toggle-nav-btn" @click="toggleNavDrawer"
        style="position: fixed; right: 0; top: 50%; transform: translateY(-50%); z-index: 100;">
        <v-icon>mdi-chat</v-icon>
      </v-btn>

      <!-- Panel de Chat AI -->
      <v-navigation-drawer app right clipped :width="navDrawerWidth" class="document-nav-drawer"
        :temporary="!isNavVisible" :value="isNavVisible" :permanent="isNavVisible"
        style="background-color: white; display: flex; flex-direction: column; z-index: 150;" flat :transition="false">
        <div class="drawer-resize-handle" @mousedown="startResize"></div>

        <v-toolbar flat class="chat-toolbar elevation-0">
          <v-toolbar-title class="font-rubik d-flex align-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="mr-2 lucide lucide-brain-icon lucide-brain">
              <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" />
              <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z" />
              <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4" />
              <path d="M17.599 6.5a3 3 0 0 0 .399-1.375" />
              <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5" />
              <path d="M3.477 10.896a4 4 0 0 1 .585-.396" />
              <path d="M19.938 10.5a4 4 0 0 1 .585.396" />
              <path d="M6 18a4 4 0 0 1-1.967-.516" />
              <path d="M19.967 17.484A4 4 0 0 1 18 18" />
            </svg>
            Chat Tutor IA</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon small color="grey" @click="toggleNavDrawer" style="position: absolute; top: 10px; right: 10px;">
            <v-icon color="grey" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider></v-divider>

        <!-- Contenido del Asistente IA -->
        <AIChatAssistant :document-id="null" :pdf-urls="[]" :axios-instance="axiosInstance"
          :toast-instance="toastInstance" :current-user="currentUser" style="max-height: calc(100vh - 128px);" />
      </v-navigation-drawer>
    </div>


    <v-dialog v-model="createDialog" fullscreen class="rounded-0" max-width="1200" scrollable>
      <v-sheet class="rounded-0 elevation-0 d-flex flex-column" height="100%" width="100%" flat>
        <upload :auto-selecting-document.sync="autoSelectingDocument"
          :subject-id="selectedSubject ? selectedSubject.id : null"></upload>

        <v-btn icon small @click="createDialog = false" class="toggle-btn"
          style="position: absolute; z-index: 100; top: 14px;" :style="minimize ? 'right: -30px;' : 'right: 20px;'">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-x-icon lucide-x">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </v-btn>
      </v-sheet>
    </v-dialog>


    <!-- Dialog para login -->
    <v-dialog v-model="showLoginDialog" content-class="rounded-xl" max-width="450">
      <div style="position: relative">
        <v-icon @click="showLoginDialog = false"
          style="position: absolute; top: 10px; right: 10px; z-index: 1000;">mdi-close</v-icon>
        <login-card :dialog.sync="showLoginDialog" subtitle="Inicia sesión para subir tus apuntes"
          :redirect="$route.path + '?upload=true'"></login-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import ViewDocuments from './components/ViewDocuments.vue';
import MainBar from './components/MainBar.vue';
import UploadComponent from './components/upload/Upload.vue';
import ViewSubjects from './components/ViewSubjects.vue';
import Home from "/node_modules/lucide-vue/dist/esm/icons/home.js"
import Plus from "/node_modules/lucide-vue/dist/esm/icons/plus.js"
import Upload from "/node_modules/lucide-vue/dist/esm/icons/upload.js"
import UploadCloud from "/node_modules/lucide-vue/dist/esm/icons/upload-cloud.js"
import AIChatAssistant from './document/components/AIChatAssistant.vue';
import LoginCard from '../profile/login/components/LoginCard.vue';

export default {
  name: 'Main',
  components: {
    ViewDocuments,
    MainBar,
    Upload: UploadComponent,
    ViewSubjects,
    LucideHome: Home,
    LucidePlus: Plus,
    LucideUpload: Upload,
    LucideUploadCloud: UploadCloud,
    AIChatAssistant,
    LoginCard
  },
  data: () => ({
    search: '',
    selectedItem: 0,
    createDialog: false,
    minimize: false,
    selectedSubject: null,
    educationInfo: null,
    showDropZone: false,
    autoSelectingDocument: false,
    navDrawerWidth: 450,  // Ancho del panel de chat
    isNavVisible: false,  // Panel de chat oculto por defecto
    resizing: false,      // Estado de redimensionamiento
    isCommunityView: false, // Indica si estamos en vista de comunidad
    communityId: null,       // ID de la comunidad actual
    showLoginDialog: false
  }),
  computed: {
    currentUser() {
      return this.$root.currentUser;
    },
    axiosInstance() {
      return this.axios;
    },
    toastInstance() {
      return this.$toast;
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(newVal) {
        console.log(newVal);
        if (newVal.planId) {
          this.$router.push('/go-to-premium?planId=' + newVal.planId + '&anual=' + !newVal.isMonthly);
        }

        if (newVal.upload) {
          this.createDialog = true;
        }

        // Cargar asignatura seleccionada si existe en la URL
        if (newVal.subject) {
          this.loadSubjectFromId(newVal.subject);
        } else {
          this.selectedSubject = null;
        }
      },
    },
    '$route': {
      immediate: true,
      handler(newRoute) {
        // Detectar si estamos en la vista de comunidad
        this.isCommunityView = newRoute.name === 'AsignaturasComunidad';

        if (this.isCommunityView) {
          this.communityId = newRoute.params.communityId;
          console.log('Vista de comunidad detectada, ID:', this.communityId);
        } else {
          this.communityId = null;
        }

        // Recargar información educativa cuando cambia la ruta
        this.loadEducationInfo();
      }
    },
    createDialog(val) {
      if (!val) {
        // Mantener el parámetro subject en la URL
        const query = { ...this.$route.query };
        delete query.upload;
        this.$router.push({ query });
      }
    }
  },
  mounted() {
    // Cargar preferencia de visibilidad del panel
    const savedNavVisibility = localStorage.getItem('mainChatVisible');
    if (savedNavVisibility !== null) {
      this.isNavVisible = savedNavVisibility === 'true';
    }


    // Eventos para resize del drawer
    window.addEventListener('mousemove', this.handleResize);
    window.addEventListener('mouseup', this.stopResize);

    // Evento de resize para dispositivos móviles
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy() {
    // Remover eventos de resize
    window.removeEventListener('mousemove', this.handleResize);
    window.removeEventListener('mouseup', this.stopResize);
    window.removeEventListener('resize', this.handleWindowResize);
  },
  methods: {
    openUploadDialog() {
      if (this.$root.currentUser && this.$root.currentUser.userId) {
        this.createDialog = true;
      } else {
        this.showLoginDialog = true;
      }
    },
    // Métodos para manejar el drag and drop
    handleDragOver(event) {
      event.preventDefault();
      this.showDropZone = true;
    },

    handleDragLeave(event) {
      event.preventDefault();
      this.showDropZone = false;
    },

    handleDrop(event) {
      event.preventDefault();
      this.showDropZone = false;
      this.autoSelectingDocument = true;

      const files = event.dataTransfer.files;
      if (files && files.length > 0) {
        // Verificamos si son imágenes o PDF
        const isPDF = Array.from(files).some(file =>
          file.type === 'application/pdf' ||
          file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
          file.type === 'application/msword' ||
          file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        );

        const areImages = Array.from(files).every(file =>
          file.type.startsWith('image/')
        );

        // Abrimos el diálogo de upload
        this.createDialog = true;

        console.log('Archivos detectados:', { isPDF, areImages, count: files.length });

        // Emitimos un evento para que el componente Upload lo capture
        // y procese los archivos automáticamente
        setTimeout(() => {
          this.$root.$emit('files-dropped', {
            files,
            isPDF,
            areImages
          });
        }, 500); // Aumentamos el timeout para asegurar que el componente esté listo
      }
    },

    showSubjectDocuments(subject) {
      this.selectedSubject = subject;
      // Actualizar la URL para reflejar la asignatura seleccionada
      const query = { ...this.$route.query, subject: subject.id };
      this.$router.push({ query });
    },

    goBackToSubjects() {
      this.selectedSubject = null;
      // Quitar el parámetro subject de la URL
      const query = { ...this.$route.query };
      delete query.subject;
      this.$router.push({ query });
    },

    async loadSubjectFromId(subjectId) {
      try {
        let response;

        if (this.isCommunityView) {
          // Para vista de comunidad, obtener asignatura de la comunidad
          response = await this.axios.get(`/education/subjects`, {
            params: {
              community_id: this.communityId,
              // Podríamos filtrar por subject_id si fuera necesario
            },
            headers: {
              Authorization: this.$root.token.value
            }
          });

          // Buscar la asignatura específica en los resultados
          if (response.data && response.data.length > 0) {
            const subject = response.data.find(s => s.id == subjectId);
            if (subject) {
              this.selectedSubject = subject;
            } else {
              this.goBackToSubjects();
            }
          } else {
            this.goBackToSubjects();
          }
        } else {
          // Para vista de usuario, usar la API original
          response = await this.axios.get(`/education/user-subjects/${subjectId}`, {
            headers: {
              Authorization: this.$root.token.value
            }
          });

          if (response.data) {
            this.selectedSubject = response.data;
          } else {
            this.goBackToSubjects();
          }
        }
      } catch (err) {
        console.error('Error al cargar la asignatura:', err);
        this.goBackToSubjects();
      }
    },

    async loadEducationInfo() {
      try {
        if (this.isCommunityView && this.communityId) {
          // Para vista de comunidad, obtener información de la comunidad
          const response = await this.axios.get(`/education/community/${this.communityId}`, {
            headers: {
              Authorization: this.$root.token.value
            }
          });

          if (response.data) {
            // Formatear la información de la comunidad similar a la estructura educativa del usuario
            this.educationInfo = {
              course_name: response.data.course_name || response.data.name,
              center_name: response.data.center_name,
              center_icon_url: response.data.center_icon_url,
              study_type_name: response.data.study_type_name,
              study_type_icon_url: response.data.study_type_icon_url,
              university_center_name: response.data.university_center_name,
              university_center_icon_url: response.data.university_center_icon_url,
              // Información específica de la comunidad
              community_name: response.data.name,
              community_id: response.data.id
            };

            console.log('Información de comunidad cargada:', this.educationInfo);
          }
        } else {
          // Para vista de usuario, comportamiento original
          if (!this.$root.currentUser.userId) {
            // this.$router.push('/login');
            return;
          }

          // Obtener información educativa del usuario
          const response = await this.axios.get('/profile/info?user_id=' + this.$root.currentUser.userId, {
            headers: {
              Authorization: this.$root.token.value
            }
          });

          if (response.data) {
            this.$root.currentUser.educationInfo = response.data;

            if (!response.data.education || Object.keys(response.data.education).length === 0) {
              // this.$router.push('/start-3', { query: this.$route.query });
              this.$router.push('/app/apuntes-preguntas-flashcards/2027')
            } else {
              this.educationInfo = response.data.education;
              console.log('Información educativa:', this.educationInfo);
            }
          }
        }
      } catch (err) {
        console.error('Error al cargar información educativa:', err);
      }
    },

    // Método para mostrar/ocultar el panel de chat
    toggleNavDrawer() {
      this.isNavVisible = !this.isNavVisible;
      // Guardar preferencia en localStorage
      localStorage.setItem('mainChatVisible', this.isNavVisible);
    },

    // Métodos para permitir redimensionar el panel
    startResize(e) {
      this.resizing = true;
      window.addEventListener('mousemove', this.handleResize);
      window.addEventListener('mouseup', this.stopResize);
    },

    handleResize(e) {
      if (!this.resizing) return;
      const newWidth = window.innerWidth - e.clientX;
      if (newWidth >= 300 && newWidth <= window.innerWidth * 0.7) {
        this.navDrawerWidth = newWidth;
      }
    },

    stopResize() {
      this.resizing = false;
    },

    handleWindowResize() {
      if (window.innerWidth < 600 && this.isNavVisible) {
        this.navDrawerWidth = window.innerWidth * 0.85;
      }
    }
  }
};
</script>

<style scoped>
.drive-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
}

.drive-header {
  background-color: white;
  border-bottom: 1px solid #f0f0f0;
  height: 64px;
}

.drive-search {
  background-color: #f5f5f5;
  border-radius: 8px !important;
}

.drive-search>>>.v-input__slot {
  min-height: 40px !important;
}

.crea-btn {
  background-color: #5271ff !important;
  color: white !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  height: 40px !important;
  padding: 0 20px !important;
}

.drive-content {
  flex: 1;
  overflow: hidden;
}

.drive-sidebar {
  background-color: #f8f8f8 !important;
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.v-navigation-drawer--minimize {
  width: 56px !important;
}

.v-navigation-drawer--minimize .v-list-item {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.v-navigation-drawer--minimize .v-list-item__icon {
  margin-right: 0 !important;
}

.sidebar-item {
  border-radius: 0 !important;
  margin-bottom: 4px;
}

.sidebar-item.v-list-item--active {
  background-color: rgba(82, 113, 255, 0.1) !important;
}

.sidebar-item.v-list-item--active .v-icon,
.sidebar-item.v-list-item--active .v-list-item__title {
  color: #5271ff !important;
}

.bottom-sidebar {
  margin-top: auto;
}

.premium-box {
  background: linear-gradient(135deg, #7e57ff, #9254de);
  border-radius: 8px;
}

.drive-main-content {
  overflow-y: auto;
  padding-bottom: 100px !important;
  transition: width 0.3s ease;

  /* background-color: white; */

  background-color: #F6F5F1;
  opacity: 1;
  background-image: radial-gradient(#cddecd 1px, #ECF8ED 1px);
  background-size: 20px 20px;
  background-repeat: repeat;
}

h1,
h2,
h3,
h4,
.text-h5,
.text-h6 {
  font-family: "Inter", "Roboto", sans-serif !important;
  color: #333 !important;
}

.v-btn.primary-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 800 !important;
  font-size: 0.9rem !important;
  border-radius: 13px !important;
  transition: filter 0.2s ease, transform 0.1s ease !important;
  height: 38px !important;
  max-height: 38px !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  border: 2px solid #4dd453 !important;
  background-color: #4dd453 !important;
  box-shadow: 0 4px 0 #42b848 !important;
  color: white;
}

.brand-link {
  position: relative;
  transition: transform 0.3s ease;
}

.brand-link:hover {
  /* No transform */
}

.logo-container {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(130, 177, 255, 0.1) 0%, rgba(68, 138, 255, 0.05) 100%);
  overflow: hidden;
  transition: all 0.3s ease;
}

.brand-link:hover .logo-container {
  box-shadow: 0 4px 12px rgba(130, 177, 255, 0.15);
}

.logo-image {
  transition: all 0.3s ease;
}

.brand-link:hover .logo-image {
  /* No transform */
}

.brand-text {
  color: #4dd453;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif !important;
  font-size: 1.7rem !important;
  font-weight: 900 !important;
  letter-spacing: -0.02;
  transition: all 0.3s ease;
}

.brand-link:hover .brand-text {
  background: linear-gradient(90deg, #4dd453, #4fee57);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.toggle-btn {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.toggle-btn:hover {
  opacity: 1;
}

.brand-link {
  flex: 1;
}

.blur-effect {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 150px;
  background: linear-gradient(to top,
      rgba(246, 245, 241, 0.95) 0%,
      rgba(246, 245, 241, 0.9) 20%,
      rgba(246, 245, 241, 0.85) 40%,
      rgba(246, 245, 241, 0.8) 60%,
      rgba(246, 245, 241, 0.75) 80%,
      rgba(246, 245, 241, 0.7) 100%);
  mask-image: linear-gradient(to top,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0.8) 20%,
      rgba(0, 0, 0, 0.6) 40%,
      rgba(0, 0, 0, 0.4) 60%,
      rgba(0, 0, 0, 0.2) 80%,
      rgba(0, 0, 0, 0) 100%);
  -webkit-mask-image: linear-gradient(to top,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0.8) 20%,
      rgba(0, 0, 0, 0.6) 40%,
      rgba(0, 0, 0, 0.4) 60%,
      rgba(0, 0, 0, 0.2) 80%,
      rgba(0, 0, 0, 0) 100%);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  pointer-events: none;
  z-index: 7 !important;
}

.no-scroll {
  overflow: hidden !important;
}

.v-dialog {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  background-color: white !important;
}

.v-dialog__content {
  overflow-y: hidden !important;
}

.breadcrumb {
  font-size: 1rem;
  background-color: white;
  border-radius: 12px !important;
}

.grado-header {
  background-color: white;
  margin-top: 15px;
  border-bottom: 1px solid #e0eadb;
  z-index: 2 !important;
  position: relative;
}

.course-icon {
  background-color: #f2f7f2;
  border-radius: 8px;
  padding: 4px;
  border: 1px solid #e0eadb;
}

.course-icon-small {
  background-color: #f2f7f2;
  border-radius: 4px;
  padding: 2px;
  border: 1px solid #e0eadb;
}

.drop-zone-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 1000;
  border: 4px dashed #4dd453;
  pointer-events: none;
}

/* Estilos para el panel de chat */
.toggle-nav-btn {
  position: fixed;
  z-index: 99;
  transition: right 0.3s ease;
}

.document-nav-drawer {
  border-left: 1px solid #e0e0e0;
}

.drawer-resize-handle {
  position: absolute;
  height: 100%;
  width: 5px;
  left: 0;
  top: 0;
  cursor: col-resize;
  z-index: 10;
}

.chat-toolbar {
  min-height: 56px !important;
  padding: 0 16px;
}
</style>